module.exports = "<div ng-repeat=\"schedule in schedules track by schedule.getPattern()\">\r\n    <h4 class=\"gw-coverage-header\" ng-class=\"{'gw-coverage-header_bop': _flavor === 'bop'}\">\r\n        <span ng-if=\"_flavor === 'default'\">{{ schedule.getDisplayName() }}</span>\r\n        <gw-heading ng-if=\"_flavor === 'bop'\">{{ schedule.getDisplayName() }}</gw-heading>\r\n    </h4>\r\n    <gw-schedule schedule=\"schedule\" loading=\"loading\" readonly=\"readonly\"></gw-schedule>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/policycommon/common/directives/templates/scheduled-coverages.html
// module id = 1024
// module chunks = 0